<template>
    <div v-if="requisicao">
        <detalhe titulo="Contrato" :size="size1" v-if="requisicao.contrato">{{
            requisicao.contrato.vcCodigoEstruturado
        }}</detalhe>
        <detalhe titulo="Fornecedor" :size="size1" v-if="requisicao.contrato">{{
            requisicao.contrato.fornecedor.nome
        }}</detalhe>
        <detalhe titulo="Processo" :size="size1">{{
            requisicao.processo
        }}</detalhe>
        <detalhe titulo="Código da Requisição" :size="size1">{{
            requisicao.vcCodigoEstruturadoRequisicao
        }}</detalhe>
        <detalhe titulo="Necessário Envio" :size="size1"
            ><app-status
                :status="requisicao.naoAutorizacaoEnvio ? 'NÃO' : 'SIM'"
            ></app-status
        ></detalhe>
        <detalhe titulo="Data Requisição" :size="size1">{{
            $moment(requisicao.dataRequisicao).format('DD/MM/YYYY')
        }}</detalhe>
        <detalhe titulo="Data Necessidade" :size="size1">{{
            $moment(requisicao.dataNecessidade).format('DD/MM/YYYY')
        }}</detalhe>
        <detalhe titulo="Objeto" :size="size1">{{ requisicao.objeto }}</detalhe>
        <detalhe titulo="Texto Complementar" :size="size1">{{
            requisicao.textoComplementar
        }}</detalhe>
        <detalhe titulo="Solicitante" :size="size1"
            >{{ requisicao.solicitante
            }}<span v-if="requisicao.contatoSolicitante">
                -
                {{ requisicao.contatoSolicitante }}</span
            ></detalhe
        >
        <detalhe titulo="Valor" :size="size1">{{
            requisicao.valor | currency
        }}</detalhe>
        <detalhe titulo="Situação" :size="size1" v-if="requisicao.situacao"
            ><app-status :status="requisicao.situacao"></app-status
        ></detalhe>
        <detalhe
            titulo="Justificativa da Finalização"
            v-if="mostrarJustificativaFinalizacao"
            :size="size1"
            >{{ requisicao.justificativaFinalizacao }}</detalhe
        >
        <detalhe
            titulo="Motivo Cancelamento"
            v-if="requisicao.motivoCancelamento"
            :size="size1"
            >{{ requisicao.motivoCancelamento }}</detalhe
        >
        <detalhe
            titulo="Cancelada em"
            :size="size1"
            v-if="requisicao.dataCancelamento"
            >{{
                $moment(requisicao.dataCancelamento).format('DD/MM/YYYY')
            }}</detalhe
        >
        <detalhe
            titulo="Cancelada por"
            :size="size1"
            v-if="requisicao.usuarioCancelamento"
            >{{ requisicao.usuarioCancelamento }}</detalhe
        >
    </div>
</template>

<script>
import { situacaoRequisicao } from './SituacaoRequisicao'

export default {
    props: {
        requisicao: {
            type: Object
        }
    },

    data() {
        return {
            size1: '160'
        }
    },

    methods: {},

    computed: {
        mostrarJustificativaFinalizacao() {
            if (this.requisicao) {
                return (
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.FINALIZADA &&
                    this.requisicao.justificativaFinalizacao
                )
            } else {
                return false
            }
        }
    },

    created() {},

    watch: {}
}
</script>
